/** Data civil local (Y/M/D) a partir de ISO/date string. */
function toCivilParts(value: string | Date | null | undefined): {
  y: number;
  m: number;
  d: number;
} | null {
  if (value == null || value === '') return null;
  if (typeof value === 'string') {
    const m = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (m) {
      return { y: Number(m[1]), m: Number(m[2]), d: Number(m[3]) };
    }
  }
  const dt = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(dt.getTime())) return null;
  return { y: dt.getFullYear(), m: dt.getMonth() + 1, d: dt.getDate() };
}

function civilToUtcMs(p: { y: number; m: number; d: number }): number {
  return Date.UTC(p.y, p.m - 1, p.d);
}

/** Diferença em meses calendário (pode ser negativa se end < start). */
export function calendarMonthsBetween(
  from: { y: number; m: number; d: number },
  to: { y: number; m: number; d: number }
): number {
  let months = (to.y - from.y) * 12 + (to.m - from.m);
  if (to.d < from.d) months -= 1;
  return months;
}

function calendarDaysBetween(
  from: { y: number; m: number; d: number },
  to: { y: number; m: number; d: number }
): number {
  const ms = civilToUtcMs(to) - civilToUtcMs(from);
  return Math.round(ms / 86_400_000);
}

/**
 * Label pt-BR: meses/dias até o término vs hoje (data civil).
 * - futuro: "faltam N mês(es)" / "faltam X dia(s)"
 * - passado: "encerrado há N mês(es)" / "encerrado há X dia(s)"
 * - sem fim: null
 */
export function formatRemainingUntilEnd(
  dataFim: string | Date | null | undefined,
  today: Date = new Date()
): string | null {
  const end = toCivilParts(dataFim);
  if (!end) return null;
  const now = {
    y: today.getFullYear(),
    m: today.getMonth() + 1,
    d: today.getDate(),
  };

  const days = calendarDaysBetween(now, end);
  if (days === 0) return 'encerra hoje';

  if (days > 0) {
    const months = calendarMonthsBetween(now, end);
    if (months < 1) {
      return days === 1 ? 'falta 1 dia' : `faltam ${days} dias`;
    }
    return months === 1 ? 'falta 1 mês' : `faltam ${months} meses`;
  }

  const daysPast = -days;
  const monthsPast = calendarMonthsBetween(end, now);
  if (monthsPast < 1) {
    return daysPast === 1 ? 'encerrado há 1 dia' : `encerrado há ${daysPast} dias`;
  }
  return monthsPast === 1 ? 'encerrado há 1 mês' : `encerrado há ${monthsPast} meses`;
}

export function formatPeriodoRange(
  dataInicio: string | Date | null | undefined,
  dataFim: string | Date | null | undefined,
  formatDateFn: (v: string | Date | null | undefined) => string
): string {
  const ini = dataInicio ? formatDateFn(dataInicio) : '—';
  const fim = dataFim ? formatDateFn(dataFim) : '—';
  return `${ini} → ${fim}`;
}
